export default class ClientSync {
    constructor(api) {
        this.api = api;
        this.clientSyncClass = null;
    }

    async init(instance) {
        if (this.api && this.api.settings && this.api.settings.clientSyncInstance && this.api.settings.clientSyncInstance !== instance.instance) {
            return;
        }

        if (!this.clientSyncClass) {
            if (instance.data && instance.data.cdn && instance.data.cdn.js) {
                await this.api.util.loadJS(instance.data.cdn.js);
            }
        }

        const data = {
            "collect": ["UI_CLICK"]
        }

        const settings = {
            mode: 'GAME_BRIDGE'
        }

        if (window.ClientSyncProcessor) {
            this.clientSyncClass = new window.ClientSyncProcessor({...settings,...data},this.api.comm.socket,1);
            window._clientSync = this.clientSyncClass;
        }
    }
}